import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { ExcelService } from './../../../services/excel.service';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Bus } from './../../../models/bus';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';
import { depenses } from './../../../models/depenses';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-depenses-statistics',
  templateUrl: './depenses-statistics.component.html',
  styleUrls: ['./depenses-statistics.component.css']
})
export class DepensesStatisticsComponent implements OnInit {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
  
  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    type: '',
    title: '',
    dateInterval: [
      new Date(moment(this.currentYear+'-08-20').format('YYYY-MM-DD')),
      new Date(moment().format('YYYY-MM-DD'))
    ],
  };
  staticFilter: any;
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------


  clients: any[];
  schools: any[];
  buses: any[];
  expenses: any[];
  pnotify = undefined;
  isResponsible = false;
  typeData: any[];
  selectedType: any;
  expense: depenses;
  loadData = false;
  isFirstFilter = true;
  totalExpenses: any;
  

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: {};
  chart2Options: {};

  detailsTotalExpenses = [
    { color: 'blue' , label: 'Gazoil      :', number: 0 },
    { color: 'red'  , label: 'Assurance   :', number: 0 },
    { color: 'green', label: 'Vidange     :', number: 0 },
    { color: 'orange', label: 'Viste Tech. :', number: 0 },
    { color: 'pink', label: 'Reparation  :', number: 0 },
    { color: 'gray', label: 'Autres      :', number: 0 },

  ];
  categories: { months: string[], buses: string[] };
  periodTypeExpense: any[];

  private getRandomNumber(): number {
    return Math.floor(Math.random() * 10000); // Adjust range as needed
  }


  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    private excelService: ExcelService,
    pnotifyService: PNotifyService
  ) { 
    this.categories = {
      months: [],
      buses: []
    };
    this.periodTypeExpense = [[], []];
    this.initClientSelect();
    this.initExpenseType();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit() {

    // Check if the current date is before August 20th of the current year
    // If so, decrement the currentYear by 1
    // Info: annee scolaire commence en 20/08/xxxx
    if (this.currentDate < new Date(this.currentYear, 7, 20)) {
      this.currentYear--;
    }
    this.filter.dateInterval[0] = new Date(moment(this.currentYear+'-08-20').format('YYYY-MM-DD'));

  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
        this.initSchoolSelect();
      });
    }
    this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.filter.schoolId = schools.length ? schools[0].id : '';
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { 
            id: school.id, 
            text: school.name,
            selected: (index === 0) ? true : false
          };
        }
      });
      this.schoolsData = array1.concat(array2);
      this.busesData = [{ id: '', text: 'Tous' }];
      this.initBusSelect();
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Tous' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);

      if (this.isFirstFilter) {
        this.onFilter();
      }
    });
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
  }

  initExpenseType(){
    this.typeData = [
      { id: '', text: 'Tous'},                
      { id: 'Gazoil', text: 'Gazoil'},
      { id: 'Assurance', text: 'Assurance'},
      { id: 'Vidange', text: 'Vidange'},
      { id: 'VisteT', text: 'Visite technique'},
      { id: 'Reparation', text: 'Reparation'},
      { id: 'Autre', text: 'Autre'},
    ];
  }

  typeFiltreChanged(e: any){
    this.filter.type = e.value;
  }

  formatDate(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  initCharts2Options() {

    this.chart2Options = {
      chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          rotation: -45,
        },
        categories: this.categories.months
      },
      yAxis: {
        title: {
          text: ''
        },
        plotLines: [{
          value: 0,
          width: 1,
          color: '#808080'
        }],
        labels: {
          formatter: function () {
            return this.value + ' DH';
          }
        },
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        borderWidth: 0
      },
      // plotOptions: {
      //   series: {
      //     label: {
      //       connectorAllowed: false
      //     },
      //     pointStart: 2010
      //   }
      // },
      series: this.periodTypeExpense,
      colors: ['blue', 'red', 'green', 'orange', 'pink', 'gray'] // Add your desired colors here
    };
  }
  
  onFilter(): void {
    this.loadData = true;//start loading data
    this.http.post(
      '/api/depenses/statistics',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      this.totalExpenses = resp.totalExpenses.toFixed(0);
      this.periodTypeExpense = resp.periodTypeExpense;
      this.categories.months = resp.months;
      this.detailsTotalExpenses[0].number = resp.gazoilTotalExpenses.toFixed(0);
      this.detailsTotalExpenses[1].number = resp.assuranceTotalExpenses.toFixed(0);
      this.detailsTotalExpenses[2].number = resp.vidangeTotalExpenses.toFixed(0);
      this.detailsTotalExpenses[3].number = resp.visteTechTotalExpenses.toFixed(0);
      this.detailsTotalExpenses[4].number = resp.reparationTotalExpenses.toFixed(0);
      this.detailsTotalExpenses[5].number = resp.autresTotalExpenses.toFixed(0);
      this.initCharts2Options();
    });
    
    console.log('this.detailsTotalExpenses');
    console.log(this.detailsTotalExpenses);
    this.loadData = false;//data ready to show
  }

}



// WEBPACK FOOTER //
// ./src/app/components/depenses/depenses-statistics/depenses-statistics.component.ts